import { DynamicForm } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const EstimatedCostFormWrapperStyled = styled.div`
  padding-bottom: 1rem;
`;

export const DynamicFormStyled = styled(DynamicForm)`
  min-height: 25rem;
`;
